<template>

    <div class="relative-div">
        <img id="set_img" class="set-img" v-show="img_data!=''" :src="img_data"/>
        <b-button id="setimgBtn1" variant="outline-secondary" size="sm" type=button @click="modalOn" :class="setbtncls">
          <b-icon :icon="cameraIcon" font-scale="2" class="color-white"></b-icon>
        </b-button>
        <b-icon icon="trash" font-scale="1" class="aiimg-del color-gray" @click="delImg"></b-icon>
        <div class="aiimg-num color-gray">{{img_numb}}</div>
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'inputimg',
  props: {
    in_id: { type: Number, default: 1 },
    img_numb: { type: Number, default: 1 }
  },
  computed: {
    ...mapState([ 'cameraInput' ]),
    ...mapGetters([ 'getImage' ]),
    cameraIcon: function () {
      if (this.cameraInput === 'kit') {
        return 'camera-video'
      } else if (this.cameraInput === 'pc') {
        return 'display'
      } else {
        return 'cursor'
      }
    },
    img_data: function () {
      // console.log('img_data0:' + String(this.in_id) + ':' + String(this.img_numb))
      // let tmpImg = this.getImage({in_id: this.in_id, img_numb: this.img_numb})
      // return tmpImg.img_data // 2行を以下の1行に記載できる
      return this.getImage({in_id: this.in_id, img_numb: this.img_numb}).img_data
      /* let tmpImg = this.getImage({in_id: this.in_id, img_numb: this.img_numb}).img_data
      if (document.getElementById('img_canvas') == null) return tmpImg
      let icanvas = document.getElementById('img_canvas')
      let ictx = icanvas.getContext('2d')
      ictx.drawImage(tmpImg, 0, 0, 70, 70) // 画像をリサイズ
      console.log('img_data1:' + String(this.in_id) + ':' + String(this.img_numb) + ':' + tmpImg)
      return tmpImg */
    },
    setbtncls: function () {
      if (this.img_data === '') {
        return 'aiimg-btn aiimg-btn1'
      } else {
        return 'aiimg-btn aiimg-btn2'
      }
    }
  },
  methods: {
    modalOn () {
      // console.log('modalOn:' + String(this.in_id) + ':' + String(this.img_numb))
      this.$store.dispatch('dispModalChg', {
        s_in: this.in_id,
        s_img: this.img_numb
      })
    },
    delImg () {
      // console.log('delImage:' + String(this.in_id) + ':' + String(this.img_numb))
      this.$store.dispatch('delImage', {
        del_in: this.in_id,
        del_img: this.img_numb
      })
    }
  }
}
</script>

<style scoped>
.relative-div {
  position: relative;
}
.aiimg-num {
  position: absolute;
  bottom: 7px;
  right: 5px;
  font-size: 80%;
}
.aiimg-btn {
  height: 55px;
  width : 55px;
}
.aiimg-btn1 {
  background-color: #ccc;
  border : dotted 1px #999;
}
.aiimg-btn2 {
  background-color: #fff;
  border : 0px;
}
.aiimg-del {
  position: absolute;
  top: 5px;
  right: 5px;
}
.color-gray {
  color: #999;
}
.color-white {
  color: #fff;
}
.set-img {
  position: absolute;
  top: 0px;
  left: 1px;
  background:white;
  height: 55px;
  width : 55px;
  border-radius: 3.2px;
  border : dotted 1px #999 ;
}

</style>



// WEBPACK FOOTER //
// src/components/InputImg.vue